import { render, staticRenderFns } from "./Chat_Voice.vue?vue&type=template&id=90eae60e&scoped=true"
import script from "./Chat_Voice.vue?vue&type=script&lang=js"
export * from "./Chat_Voice.vue?vue&type=script&lang=js"
import style0 from "./Chat_Voice.vue?vue&type=style&index=0&id=90eae60e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90eae60e",
  null
  
)

export default component.exports